import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgFileBigPng({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 40 40"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M28.25 3.75c1.8 0 3.25 1.46 3.25 3.25v8H29V7a.75.75 0 00-.75-.75h-12.9V12c0 1.65-1.3 3-2.92 3.1H6.5V33c0 .41.34.75.75.75h21c.41 0 .75-.34.75-.75v-3h2.5v3c0 1.8-1.46 3.25-3.25 3.25h-21A3.25 3.25 0 014 33V14c0-.33.13-.65.37-.88l9-9c.23-.24.55-.37.88-.37h14zm-15.1 4.12L8.12 12.9h4.13a.9.9 0 00.9-.79V7.87zm.62 10.28c.67 0 1.2.05 1.57.16a2.4 2.4 0 011.63 1.44c.14.35.21.74.21 1.17 0 .94-.29 1.66-.88 2.15-.58.48-1.42.72-2.53.72h-1.4v2.23c0 .4-.1.7-.3.93a1 1 0 01-.76.33 1 1 0 01-.79-.33c-.2-.22-.29-.53-.29-.92v-6.62c0-.43.1-.76.33-.96.22-.2.55-.3.97-.3h2.24zM25.6 18c.3 0 .55.1.74.32.18.2.26.5.26.88v6.75c0 .86-.39 1.33-1.13 1.33a1.27 1.27 0 01-.9-.33c-.13-.1-.24-.23-.34-.38l-.29-.4-2.9-4.44v4.36c0 .37-.09.67-.28.88a.95.95 0 01-.73.31c-.3 0-.56-.1-.74-.32-.19-.21-.27-.5-.27-.87v-6.63c0-.3.03-.55.1-.74.1-.21.24-.39.45-.52.2-.13.43-.2.66-.2a1.17 1.17 0 01.84.34c.1.1.19.22.29.37l.27.42 2.98 4.51V19.2c0-.38.08-.67.26-.88a.92.92 0 01.73-.32zm7.26 0c.6 0 1.14.08 1.6.24.47.16.85.37 1.15.62.3.25.52.52.68.8.15.3.23.56.23.8 0 .27-.1.5-.3.7a1.02 1.02 0 01-1.54-.14l-.2-.3a5.05 5.05 0 00-.33-.44 1.4 1.4 0 00-.54-.38 2.1 2.1 0 00-.87-.16c-.38 0-.71.07-1 .2-.3.12-.54.3-.74.54-.2.25-.37.54-.48.9-.11.37-.17.77-.17 1.21 0 .97.22 1.7.65 2.2.42.5 1.01.75 1.78.75.39 0 .74-.05 1.08-.15.3-.1.62-.22.93-.38v-1.08h-1.15c-.35 0-.63-.05-.83-.17-.23-.14-.35-.37-.35-.67 0-.25.1-.46.27-.63a1 1 0 01.7-.24h1.98c.25 0 .48.03.66.08.22.05.4.17.52.36.13.19.2.45.2.78v1.65c0 .24-.03.43-.08.59-.05.16-.15.3-.3.44-.12.11-.28.22-.47.33a6.25 6.25 0 01-5.04.52 4 4 0 01-2.4-2.41 5.46 5.46 0 01-.31-1.92c0-.69.1-1.32.3-1.9a3.96 3.96 0 012.42-2.42 5.61 5.61 0 011.95-.32zm-19.52 1.85h-.98v2.23h.98c.39 0 .71-.04.96-.12a1 1 0 00.53-.35c.12-.16.18-.37.18-.65 0-.33-.1-.59-.28-.79-.18-.18-.58-.3-1.18-.31h-.21z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgFileBigPng.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgFileBigPng.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgFileBigPng svgRef={ref} {...props} />);
export default ForwardRef;
